import { NzSafeAny } from "ng-zorro-antd/core/types";
import { isPromise } from "ng-zorro-antd/core/util";
import { noop } from "rxjs";
import { UiModalButtonOptions } from "../modal.models";

export function getValueWithConfig<T>(userValue: T | undefined, configValue: T | undefined, defaultValue: T): T | undefined {
  return typeof userValue === "undefined" ? (typeof configValue === "undefined" ? defaultValue : configValue) : userValue;
}

/**
 * The `onClick` function can return any object, however there is certain logic behind the result:
 * - If the result is `false` or a promise that results in `false` - the modal won't be closed
 * - In all other cases, the modal wil be automatically closed with the given result
 */
export const okButton = <T>(label: string, options: Omit<UiModalButtonOptions<T>, "label" | "type"> = {}): UiModalButtonOptions<T> => {
  const { onClick, ...restOptions } = options;
  return {
    type: "primary",
    shape: "round",
    size: "large",
    ...restOptions,
    onClick: (component, modalRef): NzSafeAny | Promise<NzSafeAny> => {
      if (!onClick) {
        modalRef.close();
        return;
      }

      const closeIfNotFalse = (result?: unknown): unknown => {
        if (result !== false) {
          modalRef.close(result);
        }
        return result;
      };

      const result = onClick.call(this, component, modalRef);
      if (isPromise(result)) {
        return result.then((promiseResult) => closeIfNotFalse(promiseResult), noop);
      }

      return closeIfNotFalse(result);
    },
    label,
  };
};

export const cancelButton = <T>(label: string, options: Omit<UiModalButtonOptions<T>, "label" | "type"> = {}): UiModalButtonOptions<T> => ({
  shape: "round",
  size: "large",
  onClick: (component, modalRef) => modalRef.close(),
  ...options,
  label,
});
